import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d745864&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=4d745864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d745864",
  null
  
)

export default component.exports